import type { FunctionComponent } from 'react'
import React from 'react'

import { JumplinksInline } from '../../../../shared/components/JumplinksInline'

export const SuperCategoryJumpLinks: FunctionComponent<Props> = ({ links }) => {
  if (!links?.length || links.length === 1) {
    return null
  }

  const prefixedJumplinks = links.map((link) => ({ ...link, prefix: 'super-category' }))

  return <JumplinksInline links={prefixedJumplinks} />
}

///////// IMPLEMENTATION /////////

export type Props = { links: { id: number | string; label: string }[] | undefined }
